module.exports = __webpack_public_path__ + "img/American_Credit_Business_Loans_Process_Apply_and_Approved.0737fdb.png";